const CHAT_PATH_PREFIXES = ['/chats/', '/chats', '/c/', '/c']

const isChatPath = (subPath: string): boolean =>
  CHAT_PATH_PREFIXES.some((prefix) => subPath === prefix || subPath.startsWith(`${prefix}/`))

export const getOrgSwitchTargetPath = (
  currentPathname: string,
  currentOrgSlug: string | undefined,
  targetOrgSlug: string | null
): string => {
  if (!targetOrgSlug) return '/'

  const subPath = currentOrgSlug
    ? currentPathname.replace(`/${currentOrgSlug}`, '')
    : currentPathname

  if (isChatPath(subPath)) {
    return `/${targetOrgSlug}`
  }

  return `/${targetOrgSlug}${subPath || ''}`
}
